import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.song.detail');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-page-song-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.song.detail/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSongDetailComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public song: any = null;
    public profile: any = null;
    public loading = true;
    public favoriteLoading = false;

    public async ngOnInit() {
        await this.service.init();
        const id = WizRoute.segment.id;
        if (!id) { this.service.href('/recommend'); return; }
        await this.load(id);
    }

    public async load(id: string) {
        this.loading = true;
        await this.service.render();
        let { code, data } = await wiz.call("get", { id });
        if (code === 200) {
            this.song = data.song;
            this.profile = data.profile;
        }
        this.loading = false;
        await this.service.render();
    }

    public async toggleFavorite() {
        if (!this.song || this.favoriteLoading) return;
        this.favoriteLoading = true;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("toggle_favorite", { song_id: this.song.id });
            if (code === 200) {
                this.song.is_favorited = data.favorited;
            } else {
                await this.service.modal.error("즐겨찾기 변경에 실패했습니다.");
            }
        } finally {
            this.favoriteLoading = false;
            await this.service.render();
        }
    }

    public getDifficultyText(level: number): string {
        const labels: any = { 1: '매우 쉬움', 2: '쉬움', 3: '보통', 4: '어려움', 5: '매우 어려움' };
        return labels[level] || '보통';
    }
}

export default PageSongDetailComponent;